import { createCalendar } from "./core.js";
import { createCalendarSelectControl } from "./filters.js";

/**
 * SFC-specific calendar entry point.
 *
 * Wires the generic calendar core to the SFC page: category toggle pills
 * (#category-filters) registered as a filter control, the calendar multi-select
 * (#calendar-select) via the built-in control, and the Slovenian locale. The
 * category->calendar coupling flows one way: the category control reads the
 * calendar selection through controller.getFilterState("calendars").
 */
export function initCalendar(el) {
  var filtersContainer = document.getElementById("category-filters");
  var calendarSelect = document.getElementById("calendar-select");

  // Which categories the user has toggled on
  var activeFilters = new Set();
  // All category IDs (for default detection)
  var allCategoryIds = new Set();
  // category ID -> calendar ID lookup
  var catToCalendar = {};

  if (filtersContainer) {
    filtersContainer
      .querySelectorAll("[data-category]")
      .forEach(function (wrapper) {
        var catId = wrapper.getAttribute("data-category");
        var calId = wrapper.getAttribute("data-calendar-id");
        var checkbox = wrapper.querySelector("input[type='checkbox']");
        allCategoryIds.add(catId);
        if (checkbox && checkbox.checked) {
          activeFilters.add(catId);
        }
        if (calId) {
          catToCalendar[catId] = calId;
        }
      });
  }

  var controllerRef = null;

  function isCategoryVisible(catId) {
    var calId = catToCalendar[catId];
    if (!calId) return true;
    var state = controllerRef && controllerRef.getFilterState("calendars");
    return !state || state.active.has(calId);
  }

  function updateCategoryPills() {
    if (!filtersContainer) return;
    filtersContainer
      .querySelectorAll("[data-category]")
      .forEach(function (wrapper) {
        var catId = wrapper.getAttribute("data-category");
        wrapper.style.display = isCategoryVisible(catId) ? "" : "none";
      });
  }

  var categoryControl = {
    key: "categories",
    predicate: function (e) {
      var catId = String(e.extendedProps.categoryId);
      return activeFilters.has(catId) && isCategoryVisible(catId);
    },
    serialize: function () {
      if (activeFilters.size === allCategoryIds.size) return null;
      var ids = Array.from(activeFilters).sort().join(",");
      return ids || null;
    },
    getState: function () {
      return { active: activeFilters, all: allCategoryIds };
    },
    init: function (ctx) {
      controllerRef = ctx.controller;
      if (!filtersContainer) return;
      filtersContainer.addEventListener("change", function (e) {
        var checkbox = e.target;
        if (checkbox.type !== "checkbox") return;
        var wrapper = checkbox.closest("[data-category]");
        if (!wrapper) return;
        var catId = wrapper.getAttribute("data-category");
        if (checkbox.checked) {
          activeFilters.add(catId);
        } else {
          activeFilters.delete(catId);
        }
        ctx.triggerChange("categories");
      });
    },
  };

  var filters = [];
  if (calendarSelect) {
    filters.push(
      createCalendarSelectControl(el, { selectId: "calendar-select" }),
    );
  }
  filters.push(categoryControl);

  var controller = createCalendar(el, {
    filters: filters,
    onReady: function () {
      updateCategoryPills();
    },
  });
  controllerRef = controller;

  controller.onFilterChange(function () {
    updateCategoryPills();
  });

  return controller;
}
